module.exports = __webpack_public_path__ + "static/media/sound5.0b77f060.mp3";